
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73TCo", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $21316eb17a577fc6$export$461c2ed3163c74ff);

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $2eb96 = parcelRequire("2eb96");

var $h3wYQ = parcelRequire("h3wYQ");

var $8jJQh = parcelRequire("8jJQh");

var $dF1Nh = parcelRequire("dF1Nh");

var $24JrB = parcelRequire("24JrB");

var $7LK1f = parcelRequire("7LK1f");

var $61vzn = parcelRequire("61vzn");

var $hAnPj = parcelRequire("hAnPj");

var $i5Ioa = parcelRequire("i5Ioa");

var $cOQgu = parcelRequire("cOQgu");
var $dKIZZ = parcelRequire("dKIZZ");
var $gz8ZY = parcelRequire("gz8ZY");

var $2tne1 = parcelRequire("2tne1");

var $2WkeQ = parcelRequire("2WkeQ");

var $koDo7 = parcelRequire("koDo7");

var $c5zvz = parcelRequire("c5zvz");

var $liCZ6 = parcelRequire("liCZ6");
const $21316eb17a577fc6$export$461c2ed3163c74ff = ()=>{
    const { nav4AdminOptedIn: isSiteWideNav4Enabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    (0, $cOQgu.useAddUFOCustomDataForNavType)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Disco'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2eb96.ConditionalCreateSpaceDrawer), null), (isSiteWideNav4Enabled || isNav4DisplayedToUser) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2tne1.Nav4FeedbackCollectorModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2WkeQ.MisalignedNavVersionsFlag), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).CC_IMPORTER,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Importer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h3wYQ.ConditionalImportContentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h3wYQ.ConditionalImportContentDrawer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ECOSYSTEM,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Ecosystem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8jJQh.ForgeGlobalKeyboardShortcuts), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ADMIN_EXPERIENCE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-AdminExperience'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dF1Nh.StorageEnforcement), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION,
        attributes: {
            errorBoundaryId: 'GlobalComponents-FlywheelAdoption'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $24JrB.OnboardingQuickstart), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthLuna'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $koDo7.TrialPlanComparisonModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5zvz.StandardToPremiumModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7LK1f.RovoVideoModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.TrialFlags), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hAnPj.LazyRestrictionsDialogMountPoint), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $liCZ6.ModernizeChangeboarding), null)), isNav4DisplayedToUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i5Ioa.ProgressBar), {
        isNav4: true
    })));
};

});
parcelRegister("2eb96", function(module, exports) {

$parcel$export(module.exports, "ConditionalCreateSpaceDrawer", () => $60b070effa9833b5$export$8b3b261467ad7423);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $bAyaS = parcelRequire("bAyaS");

const $60b070effa9833b5$var$CreateSpaceDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8t-EL",
    name: "CreateSpaceDrawerLoader",
    loader: async ()=>(await (parcelRequire("6RA7t"))).CreateSpaceDrawer
});
const $60b070effa9833b5$export$8b3b261467ad7423 = ()=>{
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    return shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
};

});
parcelRegister("6RA7t", function(module, exports) {

let $4ff3b5ebc9418ce2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4ff3b5ebc9418ce2$var$load("5IkZb"),
    $4ff3b5ebc9418ce2$var$load("glWzP"),
    $4ff3b5ebc9418ce2$var$load("el6yE"),
    $4ff3b5ebc9418ce2$var$load("3juBU"),
    $4ff3b5ebc9418ce2$var$load("6vzdH"),
    $4ff3b5ebc9418ce2$var$load("jkTol"),
    $4ff3b5ebc9418ce2$var$load("44le3"),
    $4ff3b5ebc9418ce2$var$load("hPwbm"),
    $4ff3b5ebc9418ce2$var$load("ejFOu"),
    $4ff3b5ebc9418ce2$var$load("dY7M5"),
    $4ff3b5ebc9418ce2$var$load("12s7O"),
    $4ff3b5ebc9418ce2$var$load("c6MKV"),
    $4ff3b5ebc9418ce2$var$load("aj3n8"),
    $4ff3b5ebc9418ce2$var$load("1ff0G"),
    $4ff3b5ebc9418ce2$var$load("hzK1f"),
    $4ff3b5ebc9418ce2$var$load("fqrMn"),
    $4ff3b5ebc9418ce2$var$load("fYi1a"),
    $4ff3b5ebc9418ce2$var$load("bjzRn"),
    $4ff3b5ebc9418ce2$var$load("8mzoy"),
    $4ff3b5ebc9418ce2$var$load("7a9CL"),
    $4ff3b5ebc9418ce2$var$load("ivQYH"),
    $4ff3b5ebc9418ce2$var$load("8pE8S"),
    $4ff3b5ebc9418ce2$var$load("9Bu2S"),
    $4ff3b5ebc9418ce2$var$load("42vdC"),
    $4ff3b5ebc9418ce2$var$load("P5iE2"),
    $4ff3b5ebc9418ce2$var$load("6ACCg"),
    $4ff3b5ebc9418ce2$var$load("kIjBt"),
    $4ff3b5ebc9418ce2$var$load("ffEVr"),
    $4ff3b5ebc9418ce2$var$load("joJy8"),
    $4ff3b5ebc9418ce2$var$load("aHE9G"),
    $4ff3b5ebc9418ce2$var$load("atyNV")
]).then(()=>parcelRequire('1tDKi'));

});


parcelRegister("8jJQh", function(module, exports) {

$parcel$export(module.exports, "ForgeGlobalKeyboardShortcuts", () => $053fc94f5ddb8d12$export$d15e21537dfa6cb0);

var $gwFzn = parcelRequire("gwFzn");

var $dPJCf = parcelRequire("dPJCf");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $1NBp8 = parcelRequire("1NBp8");

var $7Ndnw = parcelRequire("7Ndnw");

var $dizL5 = parcelRequire("dizL5");

var $8a9Dm = parcelRequire("8a9Dm");

var $4vC63 = parcelRequire("4vC63");
const $053fc94f5ddb8d12$export$d15e21537dfa6cb0 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: module.id,
                    module: module,
                    action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                            appId: (0, $8a9Dm.getAppId)(module),
                            envId: module.environmentId,
                            forgeManifestRoute: module.properties.route
                        }))
                }));
        }
    });
});

});

parcelRegister("dF1Nh", function(module, exports) {

$parcel$export(module.exports, "StorageEnforcement", () => $7ac3d7089b8f08ca$export$5bf713f6291006b2);

var $gwFzn = parcelRequire("gwFzn");

var $lQKRY = parcelRequire("lQKRY");

var $gXHya = parcelRequire("gXHya");

var $7fePz = parcelRequire("7fePz");
const $7ac3d7089b8f08ca$export$5bf713f6291006b2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lQKRY.StorageEnforcementFlags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gXHya.GracePeriodModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7fePz.BlockCreateModal), null));
};

});
parcelRegister("lQKRY", function(module, exports) {

$parcel$export(module.exports, "StorageEnforcementFlags", () => $3729a951937314e9$export$8df08a490eb32a33);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $3729a951937314e9$var$StorageEnforcementFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_U9ss",
    name: "StorageEnforcementFlagsLoadable",
    loader: async ()=>(await (parcelRequire("50GvS"))).StorageEnforcementFlags
});
const $3729a951937314e9$export$8df08a490eb32a33 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3729a951937314e9$var$StorageEnforcementFlagsLoadable, null) : null;
};

});
parcelRegister("50GvS", function(module, exports) {

let $3a5dee0a5b376079$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3a5dee0a5b376079$var$load("jPS1u"),
    $3a5dee0a5b376079$var$load("ijHdC"),
    $3a5dee0a5b376079$var$load("lDQ7w"),
    $3a5dee0a5b376079$var$load("dIKKx")
]).then(()=>parcelRequire('eYRFW'));

});


parcelRegister("gXHya", function(module, exports) {

$parcel$export(module.exports, "GracePeriodModal", () => $372cb008daefafdd$export$38134b9c38b2723c);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $372cb008daefafdd$var$GracePeriodModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6zo21",
    name: "GracePeriodModalLoadable",
    loader: async ()=>(await (parcelRequire("kV4Xt"))).GracePeriodModalErrorBoundary
});
const $372cb008daefafdd$export$38134b9c38b2723c = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($372cb008daefafdd$var$GracePeriodModalLoadable, null) : null;
};

});
parcelRegister("kV4Xt", function(module, exports) {

let $f3acfa25763c6804$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f3acfa25763c6804$var$load("5IkZb"),
    $f3acfa25763c6804$var$load("glWzP"),
    $f3acfa25763c6804$var$load("jPS1u"),
    $f3acfa25763c6804$var$load("8yyrA"),
    $f3acfa25763c6804$var$load("52dqm")
]).then(()=>parcelRequire('3zSMJ'));

});


parcelRegister("7fePz", function(module, exports) {

$parcel$export(module.exports, "BlockCreateModal", () => $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $2c6a471f2dd5d9be$var$BlockCreateModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mxabm",
    name: "BlockCreateModalLoadable",
    loader: async ()=>(await (parcelRequire("j9jNo"))).BlockCreateModal
});
const $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2c6a471f2dd5d9be$var$BlockCreateModalLoadable, null) : null;
};

});
parcelRegister("j9jNo", function(module, exports) {

let $039900e16d448729$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $039900e16d448729$var$load("6vzdH"),
    $039900e16d448729$var$load("jPS1u"),
    $039900e16d448729$var$load("ijHdC"),
    $039900e16d448729$var$load("gIOIL")
]).then(()=>parcelRequire('gLUng'));

});



parcelRegister("24JrB", function(module, exports) {

$parcel$export(module.exports, "OnboardingQuickstart", () => $504edb24d929a4b3$export$803d8a70000e4583);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $52id1 = parcelRequire("52id1");

const $504edb24d929a4b3$var$OnboardingQuickstartLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "A7UDO",
    name: "OnboardingQuickstartLoadable",
    loader: async ()=>{
        const { OnboardingQuickstartComponent: OnboardingQuickstartComponent } = await (parcelRequire("84TEP"));
        return OnboardingQuickstartComponent;
    }
});
const $504edb24d929a4b3$export$803d8a70000e4583 = ({ children: children })=>{
    const { isQuickstartEligible: isQuickstartEligible } = (0, $52id1.useQuickstartEligible)();
    return isQuickstartEligible() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($504edb24d929a4b3$var$OnboardingQuickstartLoadable, null, children) : null;
};

});
parcelRegister("84TEP", function(module, exports) {

let $5e19dee0cdc1a0b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5e19dee0cdc1a0b7$var$load("6vzdH"),
    $5e19dee0cdc1a0b7$var$load("jkTol"),
    $5e19dee0cdc1a0b7$var$load("aHbYg"),
    $5e19dee0cdc1a0b7$var$load("ir7Dc"),
    $5e19dee0cdc1a0b7$var$load("lHceO"),
    $5e19dee0cdc1a0b7$var$load("6dDCB"),
    $5e19dee0cdc1a0b7$var$load("5rLJa"),
    $5e19dee0cdc1a0b7$var$load("e53Dv"),
    $5e19dee0cdc1a0b7$var$load("c6MKV"),
    $5e19dee0cdc1a0b7$var$load("aiceI"),
    $5e19dee0cdc1a0b7$var$load("iiqDR"),
    $5e19dee0cdc1a0b7$var$load("dUKeO"),
    $5e19dee0cdc1a0b7$var$load("cXPC0"),
    $5e19dee0cdc1a0b7$var$load("hzK1f"),
    $5e19dee0cdc1a0b7$var$load("fqrMn"),
    $5e19dee0cdc1a0b7$var$load("fYi1a"),
    $5e19dee0cdc1a0b7$var$load("bjzRn"),
    $5e19dee0cdc1a0b7$var$load("8mzoy"),
    $5e19dee0cdc1a0b7$var$load("7a9CL"),
    $5e19dee0cdc1a0b7$var$load("ivQYH"),
    $5e19dee0cdc1a0b7$var$load("8pE8S"),
    $5e19dee0cdc1a0b7$var$load("9Bu2S"),
    $5e19dee0cdc1a0b7$var$load("42vdC"),
    $5e19dee0cdc1a0b7$var$load("P5iE2"),
    $5e19dee0cdc1a0b7$var$load("6ACCg"),
    $5e19dee0cdc1a0b7$var$load("kIjBt"),
    $5e19dee0cdc1a0b7$var$load("aZinD"),
    $5e19dee0cdc1a0b7$var$load("ffEVr"),
    $5e19dee0cdc1a0b7$var$load("5IkZb"),
    $5e19dee0cdc1a0b7$var$load("glWzP"),
    $5e19dee0cdc1a0b7$var$load("joJy8"),
    $5e19dee0cdc1a0b7$var$load("aHE9G"),
    $5e19dee0cdc1a0b7$var$load("dNm46")
]).then(()=>parcelRequire('3losQ'));

});


parcelRegister("7LK1f", function(module, exports) {

$parcel$export(module.exports, "RovoVideoModal", () => $4ff48be53273ace9$export$31575bcfa345fe24);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

const $4ff48be53273ace9$var$RovoVideoModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "bb89X",
    name: "RovoVideoModalLoadable",
    loader: async ()=>(await (parcelRequire("a2JoV"))).RovoVideoModal
});
const $4ff48be53273ace9$export$31575bcfa345fe24 = ()=>{
    return (0, $9wGTI.fg)('confluence_rovo_video_player_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH_LUNA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4ff48be53273ace9$var$RovoVideoModalLoadable, null)) : null;
};

});
parcelRegister("a2JoV", function(module, exports) {

let $74fd4f00e891b693$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $74fd4f00e891b693$var$load("6vzdH"),
    $74fd4f00e891b693$var$load("kGIBm"),
    $74fd4f00e891b693$var$load("69J1q"),
    $74fd4f00e891b693$var$load("8yyrA"),
    $74fd4f00e891b693$var$load("5IkZb"),
    $74fd4f00e891b693$var$load("glWzP"),
    $74fd4f00e891b693$var$load("aiceI"),
    $74fd4f00e891b693$var$load("ffEVr"),
    $74fd4f00e891b693$var$load("3CJXT")
]).then(()=>parcelRequire('hGU26'));

});


parcelRegister("2tne1", function(module, exports) {

$parcel$export(module.exports, "Nav4FeedbackCollectorModal", () => $d1cfd6c372349151$export$2b5e717cd94c6edd);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $biiXa = parcelRequire("biiXa");
var $29DUH = parcelRequire("29DUH");

var $6uGcC = parcelRequire("6uGcC");

var $2Nwuj = parcelRequire("2Nwuj");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $6ZZJK = parcelRequire("6ZZJK");

var $bQm3c = parcelRequire("bQm3c");

var $deyhs = parcelRequire("deyhs");
var $gz8ZY = parcelRequire("gz8ZY");
var $9hcBu = parcelRequire("9hcBu");
var $hthDv = parcelRequire("hthDv");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $b27jz = parcelRequire("b27jz");
const $d1cfd6c372349151$var$NAV_4_FEEDBACK_ENTRYPOINT_ID = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $d1cfd6c372349151$var$NAV_4_FEEDBACK_GROUP_ID = 'confluence-nav-4-sidebar';
const $d1cfd6c372349151$var$DEFAULT_CONTEXT = [
    {
        id: 'feedback-group-id',
        value: $d1cfd6c372349151$var$NAV_4_FEEDBACK_GROUP_ID
    }
];
const $d1cfd6c372349151$var$i18n = (0, $2nPZH.defineMessages)({
    feedbackCollectorTitle: {
        id: "nav4-feedback.feedback-collector.title",
        defaultMessage: "Help us improve the new navigation"
    },
    feedbackCollectorTitleDetails: {
        id: "nav4-feedback.feedback-collector.title-details",
        defaultMessage: "We\u2019d love to hear about your experience with the new navigation."
    },
    feedbackCollectorTitleDetailsOptOut: {
        id: "nav4-feedback.feedback-collector.title-details.opt-out",
        defaultMessage: "We\u2019d love to hear about your experience with the new navigation. If needed, you can <a>switch back to the old navigation</a>."
    },
    feedbackCollectorOptOutTitle: {
        id: "nav4-feedback.feedback-collector.opt-out.title",
        defaultMessage: "Switch back to the old navigation"
    },
    feedbackCollectorOptOutTitleDetails: {
        id: "nav4-feedback.feedback-collector.opt-out.title-details",
        defaultMessage: "We\u2019re sad to see you go. To help us improve the navigation for all users, please share why the new navigation didn\u2019t work well for you."
    },
    customTextAreaLabel: {
        id: "nav4-feedback.feedback-collector.custom-text-area-label",
        defaultMessage: "Let us know why you want to switch back"
    },
    submitButtonLabel: {
        id: "nav4-feedback.feedback-collector.submit-button-label",
        defaultMessage: "Switch back"
    }
});
const $d1cfd6c372349151$var$BASIC_NAV4_FEEDBACK_COLLECTOR_TEXT = {
    title: $d1cfd6c372349151$var$i18n.feedbackCollectorTitle,
    description: $d1cfd6c372349151$var$i18n.feedbackCollectorTitleDetails,
    textArea: undefined,
    buttonText: undefined
};
const $d1cfd6c372349151$var$OPT_OUT_NAV4_FEEDBACK_COLLECTOR_TEXT = {
    title: $d1cfd6c372349151$var$i18n.feedbackCollectorOptOutTitle,
    description: $d1cfd6c372349151$var$i18n.feedbackCollectorOptOutTitleDetails,
    textArea: $d1cfd6c372349151$var$i18n.customTextAreaLabel,
    buttonText: $d1cfd6c372349151$var$i18n.submitButtonLabel
};
const $d1cfd6c372349151$var$getTextRecord = (optingOut)=>{
    if (optingOut && !(0, $9wGTI.fg)('confluence_nav4_ga_phase_2') && (0, $9wGTI.fg)('confluence_nav_4')) return $d1cfd6c372349151$var$OPT_OUT_NAV4_FEEDBACK_COLLECTOR_TEXT;
    return $d1cfd6c372349151$var$BASIC_NAV4_FEEDBACK_COLLECTOR_TEXT;
};
const $d1cfd6c372349151$export$2b5e717cd94c6edd = ()=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, displayName: displayName, locale: locale } = (0, $bQm3c.useSessionData)();
    const [{ isOpen: isOpen, optingOut: optingOut }, { close: close, openOptOutModal: openOptOutModal }] = (0, $b27jz.useNav4FeedbackCollectorStore)();
    const [shouldDisplayFlag, setShouldDisplayFlag] = (0, $gwFzn.useState)(false);
    // The reminder banner should be displayed before users are a few days away from being forced into nav 4.
    // The only distinction between the two banners is the text.
    const storageKey = (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner') ? (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NAV4_PROMPT_REMINDER_BANNER_FIRST_DISMISSED : (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NAV4_PROMPT_BANNER_FIRST_DISMISSED;
    const onSiteWideNav4UpdateCompleted = ()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem(storageKey, null);
    };
    const { updateNav4OptOut: updateAdminNav4, isAdminUpdateSuccessful: isAdminUpdateSuccessful } = (0, $9hcBu.useNav4OptOut)();
    const { updateNav4OptIn: updateSiteWideNav4, isSiteWideUpdateSuccessful: isSiteWideUpdateSuccessful } = (0, $hthDv.useUpdateNav4OptIn)({
        newIsNav4OptedIn: false,
        onCompleted: onSiteWideNav4UpdateCompleted
    });
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    const textRecord = $d1cfd6c372349151$var$getTextRecord(optingOut);
    (0, $gwFzn.useEffect)(()=>{
        close();
        if (isSiteWideUpdateSuccessful && isAdminUpdateSuccessful) window.location.reload();
    }, [
        close,
        isAdminUpdateSuccessful,
        isSiteWideUpdateSuccessful,
        storageKey
    ]);
    /**
   * There are two scenarios where a user can opt out
   * EAP users: on the profile menu (personal opt out)
   * Phase 1 users: in the new features page (site-wide and personal opt out)
   */ const optOut = ()=>{
        const AUDIENCE = (0, $9wGTI.fg)('confluence_nav_4') ? 'EAP' : currentGAPhase === 1 ? 'GA' : null;
        updateAdminNav4(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'switchBackOldNavigation',
                source: 'nav4FeedbackCollector',
                attributes: {
                    isTenantUpdated: !(0, $9wGTI.fg)('confluence_nav_4'),
                    isUserUpdated: isNav4DisplayedToUser,
                    audience: AUDIENCE
                }
            }
        }).fire();
        updateSiteWideNav4();
    };
    const onSubmit = ()=>{
        if (optingOut) optOut();
    };
    // Flag is handled by GlobalFeedbackCollector component itself
    const onSubmitWithFlag = ()=>{
        if (optingOut) optOut();
        else {
            setShouldDisplayFlag(true);
            close();
        }
    };
    const context = optingOut ? [
        ...$d1cfd6c372349151$var$DEFAULT_CONTEXT,
        {
            id: 'opt-out',
            value: 'true'
        }
    ] : $d1cfd6c372349151$var$DEFAULT_CONTEXT;
    const getFeedbackTitleDetails = ()=>{
        //only show optItem when BETA/EAP FF is on 7 Phase two is not on
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if (!optingOut && !(0, $9wGTI.fg)('confluence_nav4_ga_phase_2') && (0, $9wGTI.fg)('confluence_nav_4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, intl.formatMessage($d1cfd6c372349151$var$i18n.feedbackCollectorTitleDetailsOptOut, {
            a: (chunks)=>// eslint-disable-next-line jsx-a11y/anchor-is-valid
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: "#",
                    onClick: openOptOutModal
                }, chunks)
        }));
        return textRecord.description && intl.formatMessage(textRecord.description);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isOpen && ((0, $9wGTI.fg)('confluence_modernize_feedback_consolidation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6ZZJK.GlobalFeedbackCollector), {
        showTypeField: true,
        onClose: close,
        onCloseComplete: ()=>{},
        onSubmit: onSubmit,
        feedbackSource: (0, $6ZZJK.FeedbackSource).NAV_4,
        feedbackTitleDetails: getFeedbackTitleDetails(),
        additionalFields: {
            'feedback-group-id': $d1cfd6c372349151$var$NAV_4_FEEDBACK_GROUP_ID,
            ...optingOut ? {
                'opt-out': 'true'
            } : {}
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $biiXa.default), {
        locale: locale,
        name: displayName ?? undefined,
        atlassianAccountId: userId ?? undefined,
        entrypointId: $d1cfd6c372349151$var$NAV_4_FEEDBACK_ENTRYPOINT_ID,
        onClose: close,
        onSubmit: onSubmitWithFlag,
        showTypeField: true,
        feedbackTitle: textRecord.title && intl.formatMessage(textRecord.title),
        feedbackTitleDetails: getFeedbackTitleDetails(),
        customTextAreaLabel: textRecord.textArea && intl.formatMessage(textRecord.textArea),
        submitButtonLabel: textRecord.buttonText && intl.formatMessage(textRecord.buttonText),
        additionalFields: [
            {
                id: 'customfield_10047',
                value: context.map(({ id: id, value: value })=>`${id}: ${String(value)}`).join('\n')
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6uGcC.default), {
        onDismissed: ()=>setShouldDisplayFlag(false)
    }, shouldDisplayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $29DUH.default), null)));
};

});

parcelRegister("2WkeQ", function(module, exports) {

$parcel$export(module.exports, "MisalignedNavVersionsFlag", () => $d903e4dac8e596de$export$40ad526e6a3cd784);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7aRa9 = parcelRequire("7aRa9");

var $1ytiN = parcelRequire("1ytiN");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $deyhs = parcelRequire("deyhs");
var $dKIZZ = parcelRequire("dKIZZ");
var $gz8ZY = parcelRequire("gz8ZY");
const $d903e4dac8e596de$export$40ad526e6a3cd784 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownInfoFlag = (0, $e9zUf.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG);
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const { nav4AdminOptedIn: isSiteWideNav4Enabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    /**
   * The user is an admin capable of admin-only opt-out
   * We are in GA phase 1
   * Nav 4 is opted-in at the site level
   * The user is seeing nav 3 due to prior personal preference update
   */ const navVersionsAreMisaligned = (isSiteAdmin || isAdmin) && isSiteWideNav4Enabled && currentGAPhase === 1 && !isNav4DisplayedToUser;
    (0, $gwFzn.useEffect)(()=>{
        if (!hasShownInfoFlag && navVersionsAreMisaligned) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagDescription),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagLink),
                        href: '/wiki/admin/newfeatures'
                    }
                ],
                isAutoDismiss: false
            });
            (0, $e9zUf.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG, 'true');
        }
    }, [
        hasShownInfoFlag,
        navVersionsAreMisaligned,
        flags
    ]);
    return null;
});
const $d903e4dac8e596de$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    misalignedNavVersionsFlagTitle: {
        id: "nav-versions-misaligned.flag",
        defaultMessage: "New navigation is turned on for everyone"
    },
    misalignedNavVersionsFlagDescription: {
        id: "nav-versions-misaligned.flag.description",
        defaultMessage: "You are still on the old navigation because you previously opted out. You can update your navigation preferences in settings."
    },
    misalignedNavVersionsFlagLink: {
        id: "nav-versions-misaligned.flag.link",
        defaultMessage: "Go to settings"
    }
});

});

parcelRegister("koDo7", function(module, exports) {

$parcel$export(module.exports, "TrialPlanComparisonModalMountComponent", () => $8e4a487f1ccf39b0$export$7699251dbf86d265);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $euL71 = parcelRequire("euL71");

var $fcF01 = parcelRequire("fcF01");

const $8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "z7feK",
    name: "LazyExperimentPlanSelectionModal",
    loader: async ()=>(await (parcelRequire("gt06i"))).ExperimentPlanSelectionModal
});
const $8e4a487f1ccf39b0$export$7699251dbf86d265 = ()=>{
    const { currentEdition: currentEdition } = (0, $gwFzn.useContext)((0, $fcF01.UpFlowContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null));
};

});
parcelRegister("gt06i", function(module, exports) {

let $bfcf6ec2e9096792$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bfcf6ec2e9096792$var$load("dQSCU"),
    $bfcf6ec2e9096792$var$load("5IkZb"),
    $bfcf6ec2e9096792$var$load("glWzP"),
    $bfcf6ec2e9096792$var$load("6vzdH"),
    $bfcf6ec2e9096792$var$load("joJy8"),
    $bfcf6ec2e9096792$var$load("aHE9G"),
    $bfcf6ec2e9096792$var$load("dj3mE")
]).then(()=>parcelRequire('2pYxO'));

});




//# sourceMappingURL=GlobalComponents.2c102827.js.map
